import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  Button,
  IconClose,
  Input,
  Modal,
  NotificationBanner,
} from 'takeat-design-system-ui-kit';
import { Form } from '@unform/web';
import UnformInput from '~/components/Form/Input';
import api2 from '~/services/api2';
import {
  ClosingCashierTableColumn,
  ClosingCashierTableContainer,
  ClosingCashierTableHeader,
  ClosingCashierTableRow,
} from './styles';

const OpeningBoxForPinpad = (props) => {
  const {
    isAuditClosingBoxOpened,
    toggleAuditClosingBox,
    selfServicePayments,
    allPaymentMethods,
    userCashier,
    handleSubmitAuditClosingBox,
    disableConfirmBtn,
  } = props;
  const [onlinePaymentMethods, setOnlinePaymentMethods] = useState([]);
  const getOnlinePaymentMethodsValues = useCallback(async () => {
    const url = userCashier
      ? `/restaurants/cashier-opening/methods?owner_id=${userCashier.user_id}`
      : `/restaurants/cashier-opening/methods`;
    const response = await api2.get(url);

    const methods = response.data.filter(
      (item) =>
        (item.is_online && (item.available || item.delivery_accepts)) ||
        (item.is_online && item.keyword === 'cupom_ifood')
    );

    setOnlinePaymentMethods(methods);
  }, [userCashier]);
  useEffect(() => {
    getOnlinePaymentMethodsValues();
  }, [getOnlinePaymentMethodsValues]);
  const openingBoxRef = useRef(null);
  return (
    <Modal
      style={{
        maxWidth: 800,
        maxHeight: 764,
        padding: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        position: 'relative',
      }}
      open={isAuditClosingBoxOpened}
      toggle={toggleAuditClosingBox}
    >
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <h2
            style={{
              margin: 0,
              fontWeight: 600,
              fontSize: 18,
              lineHeight: '24px',
              color: '#222',
            }}
          >
            Fechamento de caixa
          </h2>
          <IconClose
            fontSize={24}
            style={{ cursor: 'pointer' }}
            onClick={toggleAuditClosingBox}
          />
        </div>
        <p
          style={{
            margin: 0,
            fontWeight: 500,
            fontSize: 14,
            lineHeight: '20px',
            letterSpacing: 0.1,
            color: '#545454',
          }}
        >
          Informe cada método de pagamento. Apenas o &quot;Fundo de caixa final
          (Dinheiro)&quot; é obrigatório.
        </p>
      </div>
      <div>
        <NotificationBanner
          isOpen
          variant="info"
          style={{
            maxWidth: 768,
          }}
        >
          <p
            style={{
              margin: 0,
              fontWeight: 500,
              fontSize: 14,
              lineHeight: '20px',
              letterSpacing: 0.1,
              color: '#545454',
            }}
          >
            Os pagamentos recebidos via totem, pagamentos online e resgates do
            clube já entram automaticamente na coluna “Recebimento Automático”.
            Os demais pagamentos devem ser informados na coluna “Recebimento
            Manual”.
          </p>
        </NotificationBanner>
      </div>
      <Form
        onSubmit={handleSubmitAuditClosingBox}
        ref={openingBoxRef}
        onKeyPress={(e) => {
          e.key === 'Enter' && e.preventDefault();
        }}
        style={{
          overflow: 'auto',
          marginBottom: 56,
        }}
      >
        <ClosingCashierTableContainer
          style={{
            borderRadius: 8,
            // height: 496,
            overflow: 'auto',
            border: '1px solid #f6f6f6',
          }}
        >
          <ClosingCashierTableHeader>
            <ClosingCashierTableColumn>
              Método de pagamento
            </ClosingCashierTableColumn>
            <ClosingCashierTableColumn>
              Recebimento Automático
            </ClosingCashierTableColumn>
            <ClosingCashierTableColumn>
              Recebimento Manual
            </ClosingCashierTableColumn>
          </ClosingCashierTableHeader>
          <ClosingCashierTableRow style={{ display: 'flex' }}>
            <ClosingCashierTableColumn>
              Fundo de caixa final (Dinheiro) *
            </ClosingCashierTableColumn>
            <ClosingCashierTableColumn>
              <Input
                disabled
                placeholder="R$ 0,00"
                style={{
                  textAlign: 'center',
                }}
              />
            </ClosingCashierTableColumn>
            <ClosingCashierTableColumn>
              <UnformInput
                placeholder="R$ 0,00"
                name="final_value"
                type="number"
                step="0.01"
                min="0"
                style={{
                  textAlign: 'left',
                  marginTop: 0,
                  marginBottom: 0,
                }}
              />
            </ClosingCashierTableColumn>
          </ClosingCashierTableRow>
          {allPaymentMethods &&
            allPaymentMethods.length > 0 &&
            allPaymentMethods
              .filter(
                (method) =>
                  method.keyword !== 'dinheiro' &&
                  method.keyword !== 'prazo' &&
                  method.keyword !== 'credit_card_auto' &&
                  method.keyword !== 'pix_auto' &&
                  method.keyword !== 'online_ifood' &&
                  method.keyword !== 'cupom_ifood' &&
                  method.keyword !== 'ifood_offline'
              )
              .map((method) => (
                <ClosingCashierTableRow
                  style={{ display: 'flex' }}
                  key={method.id}
                >
                  <ClosingCashierTableColumn>
                    {method.label}
                  </ClosingCashierTableColumn>
                  {selfServicePayments.find(
                    (payment) => payment.payment_method_id === method.value
                  ) ? (
                    <ClosingCashierTableColumn>
                      <Input
                        disabled
                        placeholder={`R$ ${selfServicePayments
                          .find((p) => p.payment_method_id === method.value)
                          .total_value.replace('.', ',')}`}
                        style={{
                          textAlign: 'center',
                        }}
                      />
                    </ClosingCashierTableColumn>
                  ) : (
                    <ClosingCashierTableColumn>
                      <Input
                        disabled
                        placeholder="R$ 0,00"
                        style={{
                          textAlign: 'center',
                        }}
                      />
                    </ClosingCashierTableColumn>
                  )}
                  <ClosingCashierTableColumn>
                    <UnformInput
                      placeholder="R$ 0,00"
                      name={method.value?.toString()}
                      type="number"
                      step="0.01"
                      min="0"
                      style={{
                        textAlign: 'left',
                        marginTop: 0,
                        marginBottom: 0,
                      }}
                    />
                  </ClosingCashierTableColumn>
                </ClosingCashierTableRow>
              ))}
          {selfServicePayments &&
            selfServicePayments.length > 0 &&
            selfServicePayments.map((selfServiceMethod) => {
              const paymentExistsInAllPaymentMethods = allPaymentMethods.find(
                (method) => {
                  return method.value === selfServiceMethod.payment_method_id;
                }
              );
              if (paymentExistsInAllPaymentMethods) {
                return null;
              }
              return (
                <ClosingCashierTableRow
                  style={{ display: 'flex' }}
                  key={selfServiceMethod.payment_method_id}
                >
                  <ClosingCashierTableColumn>
                    {selfServiceMethod.payment_method.name}
                  </ClosingCashierTableColumn>
                  <ClosingCashierTableColumn>
                    <Input
                      disabled
                      placeholder={`R$ ${selfServiceMethod.total_value.replace(
                        `.`,
                        ','
                      )}`}
                      style={{
                        textAlign: 'center',
                      }}
                    />
                  </ClosingCashierTableColumn>
                  <ClosingCashierTableColumn>
                    <UnformInput
                      name={selfServiceMethod.payment_method_id?.toString()}
                      placeholder="R$ 0,00"
                      type="number"
                      step="0.01"
                      min="0"
                      style={{
                        textAlign: 'left',
                        marginTop: 0,
                        marginBottom: 0,
                      }}
                    />
                  </ClosingCashierTableColumn>
                </ClosingCashierTableRow>
              );
            })}
          {onlinePaymentMethods &&
            onlinePaymentMethods.length > 0 &&
            onlinePaymentMethods.map((onlineMethod) => (
              <ClosingCashierTableRow
                style={{ display: 'flex' }}
                key={onlineMethod.id}
              >
                <ClosingCashierTableColumn>
                  {onlineMethod.name}
                </ClosingCashierTableColumn>
                <ClosingCashierTableColumn>
                  <Input
                    disabled
                    placeholder="R$ 0,00"
                    style={{
                      textAlign: 'center',
                    }}
                  />
                </ClosingCashierTableColumn>
                <ClosingCashierTableColumn>
                  <UnformInput
                    disabled
                    name={onlineMethod.id?.toString()}
                    value={onlineMethod.value}
                    style={{
                      textAlign: 'left',
                      marginTop: 0,
                      marginBottom: 0,
                    }}
                  />
                </ClosingCashierTableColumn>
              </ClosingCashierTableRow>
            ))}
        </ClosingCashierTableContainer>
        <div />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: 40,
            position: 'absolute',
            bottom: 16,
            left: 16,
            right: 16,
          }}
        >
          <Button
            style={{
              width: 115,
              height: 40,
              padding: 0,
              margin: 0,
              fontWeight: 600,
              fontSize: 14,
              lineHeight: '20px',
              letterSpacing: 0.1,
              color: '#fff',
            }}
            onClick={toggleAuditClosingBox}
          >
            Fechar
          </Button>
          <Button
            customColor="#2EC9B7"
            style={{
              width: 185,
              height: 40,
              padding: 0,
              margin: 0,
              fontWeight: 600,
              fontSize: 14,
              lineHeight: '20px',
              letterSpacing: 0.1,
              color: '#fff',
            }}
            type="submit"
            disabled={disableConfirmBtn}
          >
            Confirmar e fechar
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

OpeningBoxForPinpad.propTypes = {
  isAuditClosingBoxOpened: PropTypes.bool.isRequired,
  toggleAuditClosingBox: PropTypes.func.isRequired,
  selfServicePayments: PropTypes.arrayOf(PropTypes.object).isRequired,
  allPaymentMethods: PropTypes.arrayOf(PropTypes.object).isRequired,
  userCashier: PropTypes.objectOf(PropTypes.any).isRequired,
  handleSubmitAuditClosingBox: PropTypes.func.isRequired,
  disableConfirmBtn: PropTypes.bool.isRequired,
};

export default OpeningBoxForPinpad;
